/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type DriveOnDriverInputPatchDtoInputType = typeof DriveOnDriverInputPatchDtoInputType[keyof typeof DriveOnDriverInputPatchDtoInputType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DriveOnDriverInputPatchDtoInputType = {
  UNDEFINED: 'UNDEFINED',
  TARGET_ASSIGNED: 'TARGET_ASSIGNED',
  TARGET_UNASSIGNED: 'TARGET_UNASSIGNED',
  LOGBOOK_CHANGED: 'LOGBOOK_CHANGED',
  MIDNIGHT_CLEANUP: 'MIDNIGHT_CLEANUP',
  KICKED: 'KICKED',
} as const;
